import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "./Button.js";
export function CopyButton({ text, children, copiedLabel = "Copied", icon, copiedIcon, resetMs = 2000, variant = "secondary", onCopied, ...rest }) {
    const [copied, setCopied] = useState(false);
    const timer = useRef(undefined);
    useEffect(() => () => clearTimeout(timer.current), []);
    const copy = useCallback(async () => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            onCopied?.(text);
            clearTimeout(timer.current);
            timer.current = setTimeout(() => setCopied(false), resetMs);
        }
        catch {
            // Best-effort — the Clipboard API is unavailable in insecure contexts.
        }
    }, [text, resetMs, onCopied]);
    return (_jsx(Button, { variant: variant, leftIcon: copied ? (copiedIcon ?? icon) : icon, onClick: copy, ...rest, children: copied ? copiedLabel : children }));
}
//# sourceMappingURL=CopyButton.js.map